import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// eslint-disable-next-line
import firebase from './utils/firebase'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
